import { createSelector } from 'reselect';

import { mountSelectorAt } from 'utils/selectors';
import * as goalsSelectors from 'selectors/goals';
import * as magazineSelectors from 'selectors/magazine';

const mount = mountSelectorAt('feed');

export const getFeedPaging = mount(localState => localState.paging);

export const getFeedWidgets = mount(localState => localState.widgets);

export const getFeedItemsNormalized = mount(localState => localState.list);

export const getFeedQuestionnairesById = mount(localState => localState.feedQuestionnaires.byId);

export const getFeedQuestionnairesIsSubmitting = mount(localState => localState.feedQuestionnaires.feedQuestionnairesSubmission.isSubmitting);

export const getFeedQuestionsById = mount(localState => localState.feedQuestions.byId);

export const getFeedItems = createSelector(
  [getFeedItemsNormalized, getFeedWidgets, getFeedQuestionnairesById, getFeedQuestionsById, goalsSelectors.getGoalsById, magazineSelectors.getMagazineArticlesById],
  (feedItemsNormalized, feedWidgets, feedQuestionnairesById, feedQuestionsById, goalsById, magazineArticlesById) => {

    return feedItemsNormalized.map(feedItemNormalized => {

      if(feedItemNormalized.chatId !== undefined) {
        return { feedChat: feedWidgets.chat[feedItemNormalized.chatId] };
      }

      if(feedItemNormalized.interestsId !== undefined) {
        return { feedInterests: feedWidgets.interests[feedItemNormalized.interestsId] };
      }

      if(feedItemNormalized.journalId !== undefined) {
        const feedJournal = feedWidgets.journal[feedItemNormalized.journalId];
        return {
          feedJournal: {
            ...feedJournal,
            emojis: feedJournal.emojis.map(emoji => emoji.emoji)
          }
        };
      }

      if(feedItemNormalized.goalsId !== undefined) {
        const feedGoals = feedWidgets.goals[feedItemNormalized.goalsId];
        return {
          feedGoals: {
            ...feedGoals,
            goals: feedGoals.goals.map(goalId => goalsById[goalId])
          }
        };
      }

      if(feedItemNormalized.questionnaireId !== undefined) {
        const questionnaire = feedQuestionnairesById[feedItemNormalized.questionnaireId];
        const questions = questionnaire.questions.map(id => feedQuestionsById[id]);

        return {
          feedQuestionnaire: {
            ...questionnaire,
            questions
          }
        };
      }

      if(feedItemNormalized.articleId !== undefined) {
        return { magazineArticle: magazineArticlesById[feedItemNormalized.articleId] };
      }
    });
  }
);



/** WEBPACK FOOTER **
 ** ./src/members/state/feed/selectors.js
 **/